import { mediaQuery, ITheme } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      position: 'fixed',
      right: 44,
      zIndex: 106,

      [mediaQuery(breakpoints.tablet)]: {
        right: 0,
        left: '50%',
        transform: 'translate(-50%, 0)',
      },
    },
  }),
  { name: 'SymbolsEditor' },
);
